
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShareableLinkByToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssetByShareableLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"pToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accessType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetUserId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastAccessedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkCreatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkCreatedByUserId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetContentFileUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetGenerationTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetCurrentVersionNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetCreatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conversationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sessionStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"participantProfileId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"participantProfileEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"participantProfileFirstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"participantProfileLastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"participantProfileOrganizationName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"participantProfileOrganizationDomain"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projectId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projectName"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":771}};
    doc.loc.source = {"body":"query GetShareableLinkByToken($token: String!) {\n  getAssetByShareableLink(first: 1, pToken: $token) {\n    nodes {\n      token\n      assetId\n      organizationId\n      accessType\n      targetUserId\n      expiresAt\n      viewCount\n      lastAccessedAt\n      linkCreatedAt\n      linkCreatedByUserId\n      assetTitle\n      assetContent\n      assetContentFileUrl\n      assetType\n      assetStatus\n      assetGenerationTemplate\n      assetCurrentVersionNumber\n      assetCreatedAt\n      conversationId\n      sessionStatus\n      participantProfileId\n      participantProfileEmail\n      participantProfileFirstName\n      participantProfileLastName\n      participantProfileOrganizationName\n      participantProfileOrganizationDomain\n      projectId\n      projectName\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetShareableLinkByToken"] = oneQuery(doc, "GetShareableLinkByToken");
        
